/* this file is for
gastro + sightseeing + events overveiw + detail
 */

import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as ajaxFormMap from './scripts/ajax-form-map';
ajaxFormMap.init();

import * as googleMap from './scripts/google-map';
googleMap.init();

import * as overlayToggle from './scripts/overlay-toggle';
overlayToggle.init();